import React from "react";
import AccountMaster from './Account_Master';

const AccntMasterApp = () =>{
    return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Account Master</h5>
          </div>
        </div>
        <AccountMaster />
      </div>
    </div >
  );
};

export default AccntMasterApp;
